module.exports = "<div class=\"data-type-group-popup\">\r\n    <create-edit-popup options=\"options\"></create-edit-popup>\r\n</div>"